import { Typography, Carousel, MultiSelect, LoadingSkeleton } from "components";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import terminalSuccessImg from "assets/images/terminal-success-rate.png";
import transactionVolumeImg from "assets/images/transaction-volume.png";
import disabledTerminalImg from "assets/images/disabled-terminal.svg";
import totalAmountSettledImg from "assets/images/total-amount-settled.svg";
import totalAssignedTerminalsImg from "assets/images/total-assigned-terminals.svg";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "routes/routePaths";
import { formatAmount, getUniqueTransactionTypes } from "utils/helper";
import {
  getTerminalSummary,
  getAllData,
  getTerminalActivity,
  setSelectedTransactionTypes,
} from "redux/actions/dashboard/terminalDashboardActions";

const SummaryCards = () => {
  const navigate = useNavigate();

  const { transactionTypes, selectedTransactionTypes } = useSelector(
    (state) => ({
      transactionTypes: state.transactionsReducer,
      selectedTransactionTypes:
        state.terminalDashboardReducer.selectedTransactionTypes,
    })
  );

  const { terminalActivity, terminalSummary, transactionTypeStats } =
    useSelector((state) => state.terminalDashboardReducer);

  const { enabled, disabled } = terminalSummary.data;

  const { totalTransVolume, totalTransValue } =
    transactionTypeStats?.data || {};

  const { active, inactive, totalTerminal, successRate } =
    terminalActivity.data;

  useEffect(() => {
    getTerminalSummary();
    getTerminalActivity();
  }, []);

  return (
    <>
      <div className="">
        <Carousel>
          {totalTerminal === undefined ? (
            <div className=" pt-3 px-2">
              <LoadingSkeleton height="6rem" />
            </div>
          ) : (
            <div
              className="agg-stats-card p-2 cursor-pointer"
              onClick={() => navigate(ROUTES.terminals)}
            >
              <Typography variant="caption2" state="primary">
                Total Terminals
              </Typography>
              <div className="main-detail mt-xl-1">
                <Typography className="mt-1" state="success">
                  {totalTerminal}
                </Typography>
                <img
                  src={totalAssignedTerminalsImg}
                  alt=""
                  style={{ width: "30px" }}
                />
              </div>
            </div>
          )}

          {terminalActivity.loading ? (
            <div className=" pt-3 px-2">
              <LoadingSkeleton height="6rem" />
            </div>
          ) : (
            <div className="agg-stats-card p-2">
              <Typography variant="caption2" state="primary">
                Terminal Success Rate
              </Typography>
              <div className="main-detail mt-xl-1">
                <Typography className="mt-1" state="success">
                  {successRate || 0}%
                </Typography>
                <img src={terminalSuccessImg} alt="" />
              </div>
            </div>
          )}

          {terminalSummary.loading ? (
            <div className=" pt-3 px-2">
              <LoadingSkeleton height="6rem" />
            </div>
          ) : (
            <div className="agg-stats-card p-2">
              <Typography variant="caption2" state="primary">
                Enabled Terminals
              </Typography>
              <div className="main-detail mt-xl-1">
                <Typography className="mt-1" state="success">
                  {enabled || 0}
                </Typography>
                <img
                  src={totalAssignedTerminalsImg}
                  alt=""
                  style={{ width: "30px" }}
                />
              </div>
            </div>
          )}

          {terminalSummary.loading ? (
            <div className=" pt-3 px-2">
              <LoadingSkeleton height="6rem" />
            </div>
          ) : (
            <div className="agg-stats-card p-2 ">
              <Typography variant="caption2" state="grey">
                Disabled Terminals
              </Typography>
              <div className="main-detail mt-xl-1">
                <Typography className="mt-1" state="grey">
                  {disabled || 0}
                </Typography>
                <img
                  src={disabledTerminalImg}
                  alt=""
                  style={{ width: "50px" }}
                />
              </div>
            </div>
          )}
        </Carousel>
      </div>

      {transactionTypes.transactionTypes?.length && (
        <div style={{ width: "fit-content" }}>
          <div
            className="space-top-3 cursor-pointer d-flex align-items-center px-2 mb-2"
            style={{ width: "" }}
          >
            <Typography variant="body3">Transaction Type:</Typography> &nbsp;
            <MultiSelect
              placeholder={"All Transactions"}
              // value={selectedTransactionTypes}
              isSearchable={false}
              borderStyle="1px solid #102E88"
              clearable={false}
              handleChange={(val) => setSelectedTransactionTypes(val, false)}
              options={getUniqueTransactionTypes(
                transactionTypes?.transactionTypes
              )?.map(({ type, description }) => ({
                label: description,
                value: type,
              }))}
              onBlur={() => getAllData(false)}
              name="transaction-type-select"
            />
          </div>
          <div className="d-flex flex-wrap mb-2" style={{ maxWidth: "19rem" }}>
            {selectedTransactionTypes.length ===
              getUniqueTransactionTypes(transactionTypes?.transactionTypes)
                ?.length || !selectedTransactionTypes.length ? (
              <Typography variant="caption0">All Transactions</Typography>
            ) : (
              selectedTransactionTypes.map((transaction, i) => (
                <Typography variant="caption0" key={i}>
                  {transaction.label}
                  {i === selectedTransactionTypes.length - 1 ? "." : ","} &nbsp;
                </Typography>
              ))
            )}
          </div>
        </div>
      )}
      <div className="mb-4">
        <Carousel>
          {transactionTypeStats?.loading ? (
            <div className=" pt-3 px-2">
              <LoadingSkeleton height="6rem" />
            </div>
          ) : (
            <div className="agg-stats-card p-2">
              <Typography variant="caption2" state="primary">
                Total Transaction Volume
              </Typography>
              <div className="main-detail mt-xl-2">
                <Typography className="mt-1" state="primary">
                  {formatAmount(totalTransVolume)}
                </Typography>
                <img
                  src={transactionVolumeImg}
                  alt=""
                  style={{ height: 30, width: 30 }}
                />
              </div>
            </div>
          )}

          {transactionTypeStats?.loading ? (
            <div className="pt-3 px-2">
              <LoadingSkeleton height="6rem" />
            </div>
          ) : (
            <div className="agg-stats-card p-2">
              <Typography variant="caption2" state="primary">
                Total Transaction Value
              </Typography>
              <div className="main-detail mt-xl-2">
                <Typography className="mt-1" state="primary">
                  ₦{formatAmount(totalTransValue)}
                </Typography>
                <img
                  src={totalAmountSettledImg}
                  alt=""
                  style={{ height: 30, width: 30, marginTop: ".1rem" }}
                />
              </div>
            </div>
          )}

          {active === undefined ? (
            <div className=" pt-3 px-2">
              <LoadingSkeleton height="6rem" />
            </div>
          ) : (
            <div className="agg-stats-card p-2">
              <Typography variant="caption2" state="primary">
                Actively Transacting Terminals
              </Typography>
              <div className="main-detail mt-xl-1">
                <Typography className="mt-1" state="success">
                  {active || 0}
                </Typography>
                <img
                  src={totalAssignedTerminalsImg}
                  alt=""
                  style={{ width: "30px" }}
                />
              </div>
            </div>
          )}

          {inactive === undefined ? (
            <div className=" pt-3 px-2">
              <LoadingSkeleton height="6rem" />
            </div>
          ) : (
            <div className="agg-stats-card p-2">
              <Typography variant="caption2" state="primary">
                Inactive Terminals
              </Typography>
              <div className="main-detail mt-xl-1">
                <Typography className="mt-1" state="success">
                  {inactive || 0}
                </Typography>
                <img
                  src={totalAssignedTerminalsImg}
                  alt=""
                  style={{ width: "30px" }}
                />
              </div>
            </div>
          )}
        </Carousel>
      </div>
    </>
  );
};

export default SummaryCards;
